import React from "react";
//import Header from "./components/Header";
import JobBoardContent from "./components/JobBoardContent";
//import Footer from "./components/Footer";
import "./App.css";

const App: React.FC = () => {
  return (
    <div className="min-h-screen background antialiased font-inter text-haig-text">
      <JobBoardContent />
    </div>
  );
};

export default App;
